import { CanMatchFn, Router } from '@angular/router';
import { AuthService } from '../core/auth.service';
import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, take, map, startWith } from 'rxjs/operators';
import { Role } from '../../enums/enums';

export const authGuard: CanMatchFn = (route, segments) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const rolesLoaded$ = toObservable(auth.rolesLoaded);

  const url = '/' + segments.map((s) => s.path).join('/');

  return rolesLoaded$.pipe(
    startWith(auth.rolesLoaded()),
    filter(Boolean),
    take(1),
    map(() => {
      if (!auth.isAuthenticated()) {
        return router.createUrlTree(['/login'], {
          queryParams: { returnUrl: url },
        });
      }

      const authError = auth.authError();
      if (authError) {
        const map: any = {
          unauthorized: 401,
          forbidden: 403,
          server: 500,
        };

        return router.createUrlTree(['/error'], {
          queryParams: { code: map[authError] ?? 500 },
        });
      }

      const roles = auth.roles();
      if (!roles || roles.length === 0) {
        return router.createUrlTree(['/access-denied']);
      }

      const adminOnly = route.data?.['adminOnly'] === true;

      if (adminOnly) {
        return auth.isAdmin() ? true : router.createUrlTree(['/access-denied']);
      }

      const minRole = route.data?.['minRole'] as Role | undefined;

      if (minRole === undefined) {
        return true;
      }

      return auth.hasRole(minRole) ? true : router.createUrlTree(['/access-denied']);
    }),
  );
};
